import { useLazyQuery } from "@apollo/client";
import gql from "graphql-tag";
import { managePodcastQuery, managePodcastQueryVariables } from "../__generated__/managePodcastQuery";

const MANAGE_PODCAST_QUERY = gql`
  query managePodcastQuery($input: GetPodcastInput!) {
    getPodcastById(input: $input) {
      ok
      error
      podcast {
        id
        title
        description
        rating
        category {
          name
        }
        reviews {
          id
          review
          rating
          createdAt
        }
        subscribers {
          id
        }
        updatedAt
        episodes {
          id
          title
          updatedAt
          fileUrl
        }
      }
    }
  }
`;

export const usePodcast = () => {
  return useLazyQuery<managePodcastQuery, managePodcastQueryVariables>(MANAGE_PODCAST_QUERY, {});
};
